import { IBayesianNetwork, IBayesianNetworksParameters } from '../bayesian-networks-interfaces';

/**
 * Build parent/child graph.
 */
export const buildGraph = (params: IBayesianNetworksParameters): IBayesianNetwork => {
    const network: IBayesianNetwork = {};

    // Build node structure from arrows --------------------------
    const arrows = params.arrows || [];

    for (const [from, to] of arrows) {

        if (!network[from]) {
            network[from] = {
                nodeName: from,
                parents: [],
                cpt: [],
                level: 0,
            };
        }

        if (!network[to]) {
            network[to] = {
                nodeName: to,
                parents: [],
                cpt: [],
                level: 0,
            };
        }

        network[to].parents.push(from);
    }


    // Handle nodes without children ---------------------
    const rules = params.rules || [];

    for (const [ruleStr] of rules) {
        const target = ruleStr.split('|')[0];
        if (!network[target]) {
            network[target] = {
                nodeName: target,
                parents: [],
                cpt: [],
                level: 0,
            };
        }
    }

    // Compute levels using a fixed point method
    let changed = true;
    while (changed) {
        changed = false;
        for (const node of Object.values(network)) {
            let maxParentLevel = -1;
            for (const parent of node.parents) {
                maxParentLevel = Math.max(maxParentLevel, network[parent]?.level ?? 0);
            }
            const newLevel = maxParentLevel + 1;
            if (node.level !== newLevel) {
                node.level = newLevel;
                changed = true;
            }
        }
    }


    return network;
};

const parseRule = (ruleString?: string) : { [name: string]: boolean } => {

    if(!ruleString) return {};

    const result: {
        [name: string]: boolean
    } = {};

    const parts = ruleString.split(',').map(item => item.trim()).filter(item => item !== '');

    for(const part of parts) {
        if (part.startsWith('~')) {
            result[part.replace('~', '')] = false;
        }
        else{
            result[part] = true;
        }
    }

    return result;
};

export const parseRules = (params: IBayesianNetworksParameters, graph: IBayesianNetwork) => {

    const rules = params.rules || [];

    for (const [rule, probability] of rules) {
        const [nodeName, ruleString] = rule.split('|');
        const parentValues = parseRule(ruleString);

        graph[nodeName].cpt.push({
            parentValues,
            probability,
        });
    }
};

export const getProbabilitiesMapFromData = (params: IBayesianNetworksParameters) : Map<string, number> => {
    const map: Map<string, number> = new Map();

    for(const [rule, probability] of params.rules) {
        map.set(rule, probability);
    }

    return map;
};
